import PreventiviDetails from "./Details";
export default PreventiviDetails;
